<template>
  <GradientBorder class="min-w-40">
    <div
      class="flex px-4 py-2 gap-x-2 rounded-t-2xl bg-black/30 rounded-b-none m-[2px] justify-between border-b border-neutral-500 text-white font-semibold"
    >
      {{ legend.name }}
      <span>{{ legend.unit }}</span>
    </div>

    <div class="flex flex-col gap-2.5 text-white text-sm pl-4 py-5 pr-8">
      <div v-for="(grade, idx) in legend.grades" :key="idx" class="flex flex-row gap-3 items-center">
        <VColorPicker
          v-model="grade.color"
          :default-color="legend.grades[idx].color as string"
          class="rounded-md"
          :class="{
            'outline-none outline-green-speaker': isGradeBinActive && selectedColorId === grade.id,
            'outline-2 hover_outline hover_outline-green-speaker': isGradeBinActive,
          }"
          transform="translateX(-250px)"
          resettable
          :disabled="!isGradeBinActive"
          :is-picker-active="isGradeBinActive && defaultColor?.id === grade.id"
          @click="selectedColorId = grade.id as string"
          @update:model-value="handleColorUpdate(legend.id as string, idx, $event)"
        >
          <div :style="`background-color: ${grade.color};`" class="w-6 h-6 rounded-md" />
        </VColorPicker>
        <div v-if="idx === 0" class="flex">&ge; {{ formatValue(grade.min) }}</div>
        <div v-else class="flex">{{ formatValue(grade.min) }} &ndash; {{ formatValue(grade.max) }}</div>
      </div>
    </div>
  </GradientBorder>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { NumericalLegend } from '~/entities/drillHole'
import type { Color } from '@/composables/useDrillHoleSettings'

const props = defineProps({
  legend: {
    type: Object as PropType<NumericalLegend>,
    required: true,
  },
  defaultColor: {
    type: Object as PropType<Color | null>,
    default: null,
  },
  isGradeBinActive: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const emit = defineEmits(['select-color'])

const selectedColorId = ref<string | null>(null)

function formatValue(value = 0) {
  const precision = props.legend.summary.precision ?? 2
  return Number(value).toFixed(precision)
}

function handleColorUpdate(id: string, idx: number, newColor: string) {
  selectedColorId.value = props.legend.grades[idx].id as string
  emit('select-color', { id, idx, newColor })
}
</script>
